export const UserType = {
    SUPER: 'super',
    ADMIN: 'admin',
    POLICE: 'police',
    SUPPORT: 'support',
    ANALYST: 'analyst',
    TEAMLEADER: 'teamleader'
  };